var React = require('react');

function NotificationIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".notification-icon-svg{fill:#f12938;}")),React.createElement("path",{"className":"notification-icon-svg","d":"M11,2a9,9,0,1,1-9,9,9,9,0,0,1,9-9m0-2A11,11,0,1,0,22,11,11,11,0,0,0,11,0Z","key":1}),React.createElement("path",{"className":"notification-icon-svg","d":"M11,6a1,1,0,0,0-1,1v5a1,1,0,0,0,2,0V7a1,1,0,0,0-1-1Z","key":2}),React.createElement("path",{"className":"notification-icon-svg","d":"M11,14a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z","key":3})]);
}

NotificationIcon.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 22 22","width":"22","height":"22"};

module.exports = NotificationIcon;

NotificationIcon.default = NotificationIcon;
